import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'

import theme from 'theme'

export function OnboardingLink({ as: Component, type = 'default', ...rest }) {
  const props = {
    css: [
      type === 'contrast' && {
        color: theme.colors.white[0],

        '&:hover, &:focus': {
          color: theme.colors.white[0]
        }
      },

      type === 'muted' && {
        color: theme.colors.steel[1],
        '&:hover, &:focus': {
          color: theme.colors.steel[0]
        }
      }
    ],
    ...rest
  }
  return Component ? <Component {...props} /> : <Link to="/" {...props} />
}

OnboardingLink.propTypes = {
  as: PropTypes.any,
  type: PropTypes.oneOf(['contrast', 'muted', 'default']),
  muted: PropTypes.bool
}
